<template>
    <div class="ur-data-grid__info-item">
        <ur-dropdown class="ur-data-grid__info__per-page" :items="pagerItems" v-if="isPager"
            @input="onPageSizeChange" :value="gridInfo.pager.rowsPerPage"/>
    </div>
</template>


<script>
export default {
    name : 'urDataGridInfoModulePerPage',
    inject:['gridInfo'],
    computed : {
        isPager() {return this.gridInfo.opts.pagination},
        pagerItems() {
            var arr = this.gridInfo.opts.pagingList;
            var msg = this.gridInfo.opts.msgPerPage;
            return arr.map(d => {
                return {text: msg.replace("#",d), value:d }
            })
        }
    },
    methods : {
        onPageSizeChange(v) {
            this.gridInfo.pager.rowsPerPage = v;
            this.$nextTick(()=>{
                this.gridInfo.func.buildViewData();
            }) // it fires update grid
        }
    }
}

</script>